<template>
    <div>
        <v-layout wrap justify-space-between align-center
                  mb-4
        >
            <v-flex md6 sm5 xs12>
                <v-select
                    v-model="theme"
                    :items="themes"
                    solo
                    append-icon=""
                    :label="$t('Все темы')"
                    class="input"
                    @change="CLEAR_PAGES()"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
            <v-flex md3 sm5 xs12
                    :class="{'mt-3': $vuetify.breakpoint.xs}"
            >
                <v-select
                    :items="[$t('Сначала новые'),$t('Сначала старые')]"
                    solo
                    append-icon=""
                    :label="$t('Сначала новые')"
                    class="input"
                    @change="sorting_by_date($event)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
            <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs, 'mt-3': $vuetify.breakpoint.smAndDown}" @click.native="OPEN_MODAL('ideas_bank_modal')">{{$t("Предложить идею")}}</buttonRed>
        </v-layout>
        <v-layout class="pb-5 column">
            <template v-if="paginated.length > 0">
                <div v-for="(idea, i) in paginated" :key="i">
                    <ideaBlock class="mb-4" :content="idea"
                               :class="{'background-light': !(i%2)}" :my_ideas="true"
                    />
                </div>
            </template>
            <div v-else>{{$t("По запросу ничего не найдено")}}</div>
        </v-layout>
        <v-layout v-if="filtered_by_theme.length>10" justify-space-between align-center
                  wrap
        >
            <v-layout>
                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('ideas_bank_modal')">{{$t("Предложить идею")}}</buttonRed>
            </v-layout>
            <v-flex md5 sm7 xs12
                    :class="{'mt-3': $vuetify.breakpoint.xs}"
            >
                <div class="text-xs-center">
                    <v-pagination
                        v-model="page"
                        :length="Math.ceil(filtered_by_theme.length / selected_number)"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm5 xs12
                    mb-4 :class="{'mt-3': $vuetify.breakpoint.smAndDown}"
            >
                <v-select
                    :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                    : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                    solo
                    append-icon=""
                    :label="$t('Показывать по 10')"
                    class="input"
                    @change="show_number($event, 10)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import ideaBlock from '@/components/view_blocks/Ideas_bank/Idea_block';
import buttonRed   from '@/components/ui/buttons/button_red';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    ideaBlock,
    buttonRed,
  },
  computed: {
    ...mapGetters('activity/ideas', [
      'ideas',
      'selected_page',
      'selected_number',
      'selected_theme',
      'paginated',
      'search_string',
      'filtered_by_theme',
    ]),
    ...mapGetters('activity', [
      'themes',
    ]),
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    ideas_search: {
      get() {
        return this.search;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'OPEN_MODAL',
    ]),
    ...mapMutations('activity/ideas', [
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SORT_BY_DATE',
      'SEARCH_STRING',
    ]),
    ...mapActions('activity/ideas', [
      'show_number',
      'sorting_by_date',
    ]),
  },
};
</script>

<style>

</style>
